import { Field, Label } from '../../catalyst/fieldset';
import { Select } from '../../catalyst/select';
import { usePlatformData } from '../../hooks/usePlatformData';

// Shared Source/Category filter row used by both the curation list (CurationTable)
// and the curation history (ReviewHistory) so the two views stay in lockstep.
const SOURCE_OPTIONS = [
  { label: 'All sources', value: '' },
  { label: 'Flags', value: 'manual_flag' },
  { label: 'AI scanner', value: 'ai_scanner' },
  { label: 'Completeness', value: 'completeness' },
  { label: 'User suggested', value: 'user_mismatch' },
  { label: 'Second opinion', value: 'second_opinion' },
  { label: 'Outliers', value: 'outlier' },
  { label: 'Low certainty', value: 'low_certainty' },
];

export function CurationFilters({
  source,
  category,
  onSourceChange,
  onCategoryChange,
}: {
  source: string;
  category: string;
  onSourceChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
}) {
  const { categories } = usePlatformData();

  return (
    <div className="flex flex-wrap items-end gap-4">
      <Field className="min-w-48">
        <Label htmlFor="curation-source">Source</Label>
        <Select
          id="curation-source"
          value={source}
          onChange={(e) => onSourceChange(e.target.value)}
        >
          {SOURCE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
      </Field>
      <Field className="min-w-48">
        <Label htmlFor="curation-category">Category</Label>
        <Select
          id="curation-category"
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
          disabled={categories.isLoading}
        >
          <option value="">All categories</option>
          {(categories.data?.pageCategories ?? []).map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </Select>
      </Field>
    </div>
  );
}
